import { Div } from '../../../base/components/native/div'
import { CENTER } from '../../../base/helpers/style'
import { IProductVariant } from '../../../interfaces/product'
import { Color } from './color'
import { Size } from './size'

export const Sizes = (variants: IProductVariant[]) => {

    const base = Div()
    let selected: any = null
    variants.forEach((variant: IProductVariant, i: number) => {
        const size = variant['size'] as string
        const sizeDiv = Size(size)
        base.append(sizeDiv)
        if (i === 0) {
            selected = sizeDiv
            selected.select()
        }
        sizeDiv.el.onclick = () => {
            base.emit('select', { name: size })
            if (selected) selected.unselect()
            selected = sizeDiv
            selected.select()
        }
    })

    base.cssClass({
        ...CENTER,
        margin: '5px'
    })

    return base
}